var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMensaje(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M0 0L20 0L20 20L0 20L0 0Z",
    id: "path_1"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "mask_1"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path_1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mensaje-(1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0L20 0L20 20L0 20L0 0Z",
    id: "Background",
    fill: "#FFFFFF",
    fillOpacity: 0,
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#mask_1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(0 3.1489258)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.2422 0L1.75781 0C0.788555 0 0 0.788555 0 1.75781L0 11.9446C0 12.9139 0.788555 13.7024 1.75781 13.7024L18.2422 13.7024C19.2114 13.7024 20 12.9139 20 11.9446L20 1.75781C20 0.788555 19.2114 0 18.2422 0L18.2422 0ZM18.0129 1.17188L17.7782 1.36723L10.6975 7.26336C10.2934 7.59984 9.70672 7.59984 9.30266 7.26336L2.22191 1.36723L1.9873 1.17188L18.0129 1.17188L18.0129 1.17188ZM1.17188 2.01807L6.94109 6.82209L1.17188 10.6617L1.17188 2.01807L1.17188 2.01807ZM18.2421 12.5307L1.75777 12.5307C1.47465 12.5307 1.23785 12.3289 1.18359 12.0616L7.88066 7.60449L8.55269 8.1641C8.97199 8.51324 9.48602 8.68781 10 8.68781C10.514 8.68781 11.028 8.51324 11.4473 8.1641L12.1193 7.60449L18.8164 12.0615C18.7621 12.3289 18.5253 12.5307 18.2421 12.5307L18.2421 12.5307ZM18.8281 10.6617L13.0588 6.82213L18.8281 2.01807L18.8281 10.6617L18.8281 10.6617Z",
    id: "Shape",
    fill: "#10B48C",
    fillRule: "evenodd",
    stroke: "none"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMensaje);
export default __webpack_public_path__ + "static/media/mensaje.c04ef4c931466d081120fa25ec7705fb.svg";
export { ForwardRef as ReactComponent };